/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, Input, OnInit, signal, inject } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
// This import CANNOT be shortened because of circular dependencies.
import { FormValidationCheckerService } from '../_shared/services/form-validation-checker.service';
import { LabelComponent } from '../label/label.component';

@Component({
    selector: 'sirius-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LabelComponent, CommonModule]
})
export class TextareaComponent implements OnInit, ControlValueAccessor {
    private _ngControl = inject(NgControl, { optional: true, self: true });
    changeDetectorRef = inject(ChangeDetectorRef);
    validationService = inject(FormValidationCheckerService);

    @Input() label = '';
    @Input() id = '';
    @Input() name = '';
    @Input() toolTip = '';
    @Input() identifier = '';
    @Input() maxlength = 500;

    protected readonly focused = signal(false);
    protected readonly labelSize = computed<'s' | 'l'>(() => (this.focused() || !!this.control?.value ? 's' : 'l'));

    private _valid = new BehaviorSubject<boolean>(true);
    valid$ = this._valid.asObservable();

    get control() {
        return this._ngControl?.control as FormControl;
    }

    onChange = (value: string) => {
        //
    };

    onTouched = () => {
        //
    };

    constructor() {
        const _ngControl = this._ngControl;

        if (_ngControl) {
            _ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.control.statusChanges.subscribe((status) => {
            this._valid.next(status !== 'INVALID');
        });
    }

    // ControlValueAccessor
    writeValue = (value: string) => undefined;

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) this.control?.disable();
    }
}
